"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var moment_1 = __importDefault(require("moment"));
var LOCAL_STORAGE_KEY_BASE = "estimate_reentry_modal_";
var DATE_FORMAT = "YYYYMMDD HH:mm:ss";
var EstimateReentryModalStore = /** @class */ (function () {
    function EstimateReentryModalStore(_a) {
        var authenticityToken = _a.authenticityToken, originalEntryId = _a.originalEntryId, isOpen = _a.isOpen, onClose = _a.onClose;
        var _this = this;
        this.handleClose = function () {
            _this.isOpen = false;
            _this.onClose();
        };
        this.isHidePeriodExpired = function (lastOpenedAt) {
            return (0, moment_1.default)(lastOpenedAt, DATE_FORMAT).startOf('day').add(1, 'd').add(10, 'h').isBefore((0, moment_1.default)());
        };
        this.authenticityToken = authenticityToken;
        this.originalEntryId = originalEntryId;
        this.onClose = onClose;
        var key = LOCAL_STORAGE_KEY_BASE + originalEntryId;
        var lastOpenedAt = localStorage.getItem(key);
        this.isOpen = isOpen && !lastOpenedAt || this.isHidePeriodExpired(lastOpenedAt || '');
        if (this.isOpen) {
            localStorage.setItem(key, (0, moment_1.default)().format(DATE_FORMAT));
        }
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Boolean)
    ], EstimateReentryModalStore.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EstimateReentryModalStore.prototype, "handleClose", void 0);
    return EstimateReentryModalStore;
}());
exports.default = EstimateReentryModalStore;
